import React from 'react'

const PlayButton = props => (
  <svg width={props.width} height={props.height} viewBox="0 0 86 86" {...props}>
    <defs>
      <filter id="shadow">
        <feDropShadow dx="1" dy="1" stdDeviation="1" floodOpacity="0.3"/>
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 86h86V0H0z" />
      <path
        style={{ filter: 'url(#shadow)', fillOpacity: '0.9' }}
        fill="#FFF"
        d="M43 7c19.882 0 36 16.118 36 36S62.882 79 43 79 7 62.882 7 43 23.118 7 43 7zm0 6c-16.542 0-30 13.458-30 30s13.458 30 30 30 30-13.458 30-30-13.458-30-30-30zM32.619 25.463L61.38 41.537c1.44.806 1.44 2.122 0 2.928l-28.761 16.07c-1.44.806-2.62.114-2.62-1.535V27c0-1.65 1.18-2.343 2.62-1.538z"
      />
    </g>
  </svg>
)

export default PlayButton
